import React, { useMemo } from 'react';
import { t } from 'ttag';
import { CoolAssistantWidget } from '@coolremote/shared';
import { useStoreState } from '@models/RootStore';
import useCoolAssistant from '@hooks/useCoolAssistant';

// BE => siteIds: [...] (≤20)
const MAX_SELECTED_SITES = 20;

const CoolAssistant = () => {
  const { selections, mobileSelections } = useStoreState((s) => s.selections);
  const { enableAssistant, id: userId } = useStoreState((s) => s.users.me);
  const getCustomerSites = useStoreState((s) => s.customers.getCustomerSites);
  // Mobile flows track the selected customer/site in mobileSelections, desktop in selections.
  const customerId = mobileSelections?.customerId || selections.customerId;
  const siteId = mobileSelections?.siteId || selections.siteId;
  const {
    handleSend,
    getChatHistory,
    getRecentChats,
    handleNewChat,
    handleSelectChat,
    /* handleBack, */
    getDefaultSuggestions,
    selectedSiteIds,
    handleSelectedSiteIdsChange,
  } = useCoolAssistant(customerId, siteId, userId);
  
  const isDashboardScreen = window.location.pathname.includes("dashboard");

  const customerSites = useMemo(
    () =>
      getCustomerSites(customerId)
        .map((site) => ({ id: site.id, name: site.name }))
        .sort((a, b) => a.name.localeCompare(b.name)),
    [getCustomerSites, customerId]
  );

  if (!enableAssistant || !customerId) {
    return null;
  }

  return (
    <CoolAssistantWidget
      onSend={handleSend}
      getChatHistory={getChatHistory}
      getRecentChats={getRecentChats}
      onNewChat={handleNewChat}
      onSelectChat={handleSelectChat}
      sites={customerSites}
      selectedSiteIds={selectedSiteIds}
      onSelectedSiteIdsChange={handleSelectedSiteIdsChange}
      maxSelectedSites={MAX_SELECTED_SITES}
      // onBack={handleBack} // disabled for now, along with the back button in CoolAssistantWidget
      title={t`Control your sites with AI`}
      suggestions={getDefaultSuggestions()}
      initialHistoryDays={1}
      historyStepDays={1}
      loadMoreScrollThreshold={24}
      position={isDashboardScreen ? { bottom: 120, right: 30 } : {}}
    />
  );
};

export default CoolAssistant;
